import * as actions from "./actions.ts";
import * as INR from "./INR.ts";
import ApiServer from "./ApiServer.ts";

import "./ui/specific-family.ts";
import "./server/decoders_connected.ts";

  var
    // Private variables
    startSequenceUnlogged = actions.getStartSequence(false),
    startSequenceLogged = actions.getStartSequence(true);

  INR.createPage(
      INR.URL.FEATURES,
      function(){(window as Window).location='index.html';},
      function(){return Promise.all([])},
      "fw"
    );
  INR.createPage(
      INR.URL.PREMIUM,
      function(){(window as Window).location='premium.html';},
      function(){return Promise.all([])},
      "fw"
    );

  INR.createPage(
      INR.URL.ERROR_TOKEN,
      startSequenceUnlogged,
    function(){
      return Promise.all([import('./nc/error_token.mustache')])
    },
      "fw2"
    );


  INR.createPage(
      INR.URL.ENTER_HOME,
      startSequenceLogged,
    function(){
      return Promise.all([import('./page_home.mustache'),import('./page/home.ts')])
    },
      "fw"
    );
  INR.createPage(
      INR.URL.ACTIVITY,
      startSequenceLogged,
    function(){
      return Promise.all([import('./page_wall.mustache'),import('./page/home.ts')])
    },
      "fw"
    );

  INR.createPage(
      INR.URL.MAP,
      startSequenceLogged,
    function(){
      return Promise.all([import('./page_map.mustache'),import('./map/page_map.ts')])
    },
      "fw"
    );

  INR.createPage(
      INR.URL.IM,
      startSequenceLogged,
    function(){
      return Promise.all([import('./im/page_im.mustache'),import('./im/page_im.ts')])
    },
      "fw"
    );

  INR.createPage(
    INR.URL.CONTACTS,
    startSequenceLogged,
    function(){
      return Promise.all([import('./page_contacts.mustache'),import('./contact/page_contacts.ts')])
    },
    "fw"
  );

  INR.createPage(
    [INR.URL.EVENTS,INR.URL.EVENTS_OUTLOOKRETURN],
    startSequenceLogged,
    function(){
      return Promise.all([import('./calendar/page_calendar.mustache'),import('./calendar/page_calendar.ts')])
    },
    "fw"
  );
  INR.createPage(
    [INR.URL.SPECIALDAYS],
    startSequenceLogged,
    function(){
      return Promise.all([import('./specialdays/page_specialdays.mustache'),import('./specialdays/page_specialdays.ts')])
    },
    "fw"
  );

  INR.createPage(
      INR.URL.SETTINGS,
      startSequenceLogged,
    function(){
      return Promise.all([import('./settings/page_settings.mustache'),import('./settings/page_settings.ts')])
    },
      "fw"
    );
  INR.createPage(
      INR.URL.MEALPLANNER,
      startSequenceLogged,
    function(){
      return Promise.all([import('./mealplanner/page_mealplanner.mustache'),import('./mealplanner/page_mealplanner.ts')])
    },
      "fw"
    );
  INR.createPage(
      INR.URL.MEALPLANNER_NC,
      startSequenceUnlogged,
    function(){
      return Promise.all([import('./mealplanner/page_mealplanner_nc.mustache'),import('./mealplanner/page_mealplanner_nc.ts')])
    },
      "fw"
    );
  INR.createPage(
      INR.URL.RECIPEBOX,
      startSequenceLogged,
    function(){
      return Promise.all([import('./mealplanner/page_recipebox.mustache'),import('./mealplanner/page_recipebox.ts')])
    },
      "fw"
    );
  INR.createPage(
      INR.URL.RECIPEBOX_NC,
      startSequenceUnlogged,
    function(){
      return Promise.all([import('./mealplanner/page_recipebox_nc.mustache'),import('./mealplanner/page_recipebox_nc.ts')])
    },
      "fw"
    );
  INR.createPage(
      INR.URL.TIMETABLE,
      startSequenceLogged,
    function(){
      return Promise.all([import('./timetable/page_timetable.mustache'),import('./timetable/page_timetable.ts')])
    },
      "fw"
    );
  INR.createPage(
      INR.URL.TIMETABLE_NC,
      startSequenceUnlogged,
    function(){
      return Promise.all([import('./timetable/page_timetable_nc.mustache'),import('./timetable/page_timetable_nc.ts')])
    },
      "fw"
    );

  INR.createPage(
      INR.URL.BUDGET,
      startSequenceLogged,
    function(){
      return Promise.all([import('./budget/page_budget.mustache'),import('./budget/page_budget.ts')])
    },
      "fw"
    );
  INR.createPage(
      INR.URL.PASSWORD_FORGOTTEN,
      startSequenceUnlogged,
    function(){
      return Promise.all([import('./nc/password_forgotten.mustache'),import('./page/password_forgotten.ts')])
    },
      "fw2"
    );
  INR.createPage(
      INR.URL.PASSWORD_RESET,
      startSequenceUnlogged,
    function(){
      return Promise.all([import('./nc/password_reset.mustache'),import('./page/password_reset.ts')])
    },
      "fw2"
    );
  INR.createPage(
      INR.URL.PASSWORD_RESET_SUCCESS,
      actions.getStartSequence(false,function(callback,data){
        ApiServer.accgenerateDeepLoginLink(INR.URL.ENTER_HOME,function(link){
          data.deepLoginLink = link;
          callback(data);
        },function(){callback(data);});
      }),
    function(){
      return Promise.all([import('./nc/password_reset_success.mustache')])
    },
      "fw2"
    );
  INR.createPage(
      INR.URL.INVITATION_ALREADY_ACCEPTED,
      startSequenceLogged,
    function(){
      return Promise.all([import('./nc/invitation_already_accepted.mustache')])
    },
      "fw2"
    );
  INR.createPage(
      INR.URL.GALLERY,
      startSequenceLogged,
      function(){
        return Promise.all([import('./gallery/page_gallery.mustache'),import('./gallery/page_gallery.ts')])
      },
      "fw"
  );

  INR.createPage(
      INR.URL.TASKS,
      startSequenceLogged,
    function(){
      return Promise.all([import('./page_tasks.mustache'),import('./list/page_tasks.ts')])
    },
      "fw"
    );
  INR.createPage(
      INR.URL.FILER,
      startSequenceLogged,
    function(){
      return Promise.all([import('./filer/page_filer.mustache'),import('./filer/page_filer.ts')])
    },
      "fw"
    );



  INR.createPage(
      "launchpadV3.php",
      startSequenceLogged,
    function(){
      return Promise.all([import('./launchpadV3-table.mustache'),import('./page/launchpad-page.ts')])
    },
      "fw"
    );